import { Dispatch, SetStateAction } from 'react';

import { isMatchGateway } from 'cashout/helpers/utils';

import AmplitudeAnalytics from 'common/services/amplitude/analytics';

import { AuthServices } from '../services';
import { setCookies } from '../store/global';
import { useAppDispatch } from './hooks';
import { getQueryParam } from './url';
import { extractCustomHeaders, getOperatingSystem, getUserBrowser, OS_SYSTEM } from './utils';

export enum AstroCustomHeaders {
  STATE = 'x-astro-state',
  DISCOVER = 'x-astro-discover',
  ID = 'x-astro-id',
  SESSION = 'x-astro-session',
}

async function cookiesHandler(
  showAlert: Dispatch<SetStateAction<boolean>>,
  dispatch: ReturnType<typeof useAppDispatch>,
  cookies?: Record<AstroCustomHeaders, string>,
) {
  const data = await AuthServices.getCookiesAuth(cookies);
  const isGateway = isMatchGateway();
  const isSdk = !!getQueryParam('condensed');

  if (!data.checked) {
    AmplitudeAnalytics.cookiesBlocked(
      isSdk,
      getOperatingSystem(),
      getUserBrowser().name ?? OS_SYSTEM.UNKNOWN,
    );

    if (isGateway) {
      dispatch(setCookies(extractCustomHeaders(data, cookies)));
      return;
    }

    return showAlert(true);
  }
}

export { cookiesHandler };
